
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  VStack,
  useToast,
  IconButton,
  Badge,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
} from '@chakra-ui/react';
import { BellIcon } from '@chakra-ui/icons';
import axios from 'axios'; // Import axios for API requests
import socket from './socket';
import Notifications from './Notifications';

const BidForm = () => {
  const [itemId, setItemId] = useState('');
  const [userId, setUserId] = useState('');
  const [connected, setConnected] = useState(false);
  const [lastbid, setlastbid] = useState(false);

  const [itemDetails, setItemDetails] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [bidAmount, setBidAmount] = useState('');
  const [counts, setCounts] = useState('');
  const [bidCount, setBidCount] = useState('');
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [timeLeft, setTimeLeft] = useState('');
  const [bidHistory, setBidHistory] = useState({
    bidItems: [],
    wonItems: [],
    lostItems: [],
  });

  const toast = useToast();

  useEffect(() => {
    socket.on('connect', () => {
      setConnected(true);
      console.log('Connected to socket:', socket.id);
    });

    socket.on('connect_error', (err) => {
      console.error('Connection error:', err?.message);
    });

    socket.on('itemDetails', (details) => {
      console.log(details)
      setlastbid(details.latsbid)
      setBidCount(details?.bidCount);
      console.log(details);
      setItemDetails(details.item);
      setTimeRemaining(new Date(details.item.endDate) - new Date());
    });

    socket.on('notification', (notification) => {
      console.log(notification);
      setNotifications((prevNotifications) => [...prevNotifications, notification]);
    });

    socket.on('newBid', (bid) => {
   
      console.log(bid);
      console.log(bid.bidcount)
      setlastbid(userId===bid.latsbid)
      setBidCount(bid?.bidcount);
      if (itemDetails && itemDetails._id === bid.itemId) {
        setItemDetails((prevDetails) => ({
          ...prevDetails,
          startPrice: bid.newprice,
        }));
      }
      toast({
        title: 'New Bid Placed',
        description: `User ${bid.userId} placed a bid of $${bid.amount} and price up to ${bid.newprice}`,
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
    });

    socket.on('auctionExtended', (data) => {
      console.log(data);
      if (itemDetails && itemDetails._id === data.itemId) {
        setItemDetails((prevDetails) => ({
          ...prevDetails,
          subcategoryId: {
            ...prevDetails.subcategoryId,
            endDate: data.newEndTime,
          },
          minBidIncrement: data.newMinBidIncrement,
        }));
        setTimeRemaining(new Date(data.newEndTime) - new Date());
      }
      toast({
        title: 'Auction Extended',
        description: `Auction extended by 20 minutes. New end time: ${new Date(data.newEndTime).toLocaleString()}`,
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
      
    });
    socket.on('bidError', (message) => {
      toast({
        title: 'Bid Error',
        description: message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    });
    socket.on('usercount', (notification) => {
      console.log(notification);
      setCounts(notification.userCount);
    });

    return () => {
      socket.off('connect');
      socket.off('connect_error');
      socket.off('itemDetails');
      socket.off('notification');
      socket.off('newBid');
      socket.off('auctionExtended');
      socket.off('bidError');
      socket.off('usercount');
    };
  }, [itemDetails, counts, bidAmount, toast]);

  useEffect(() => {
    if (itemDetails && itemDetails?.subcategoryId?.endDate) {
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const endTime = new Date(itemDetails?.subcategoryId?.endDate).getTime();
        const timeRemaining = endTime - now;

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);

        if (timeRemaining < 0) {
          clearInterval(interval);
          setTimeLeft('Auction Ended');
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [itemDetails]);

  const handleConnect = () => {
    if (itemId && userId) {
      socket.auth = { itemId, userId };
      socket.connect();
      socket.emit('joinRoom', { itemId, userId });
    }
  };

  const handlePlaceBid = () => {
    if (bidAmount && itemDetails) {
      socket.emit('placeBid', {
        itemId: itemDetails._id,
        amount: Number(bidAmount),
      });
      setBidAmount('');
    }
  };

  useEffect(() => {
    if (timeRemaining > 0) {
      const interval = setInterval(() => {
        setTimeRemaining((prevTime) => prevTime - 1000);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timeRemaining]);

  // useEffect(() => {
  //   const fetchBidHistory = async () => {
  //     try {
  //       const response = await axios.get('/api/user/bid-history', {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem('token')}`, // Assuming you store the token in localStorage
  //         },
  //       });
  //       setBidHistory(response.data);
  //     } catch (error) {
  //       console.error('Error fetching bid history:', error);
  //     }
  //   };

  //   fetchBidHistory();
  // }, []);

  const formatTime = (time) => {
    const hours = String(Math.floor((time / (1000 * 60 * 60)) % 24)).padStart(2, '0');
    const minutes = String(Math.floor((time / (1000 * 60)) % 60)).padStart(2, '0');
    const seconds = String(Math.floor((time / 1000) % 60)).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  return (<Box display={'flex'}>
  <Box width={'50%'}>
     <Box maxW="md" mx="auto" mt="10" p="5" borderWidth="1px" borderRadius="lg">
      <VStack spacing="5">
        <FormControl id="itemId">
          <FormLabel>Item ID</FormLabel>
          <Input
            type="text"
            value={itemId}
            onChange={(e) => setItemId(e.target.value)}
          />
        </FormControl>
        <FormControl id="userId">
          <FormLabel>User ID</FormLabel>
          <Input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />
        </FormControl>
        <Button onClick={handleConnect} colorScheme="teal" isDisabled={connected}>
          {connected ? 'Connected' : 'Connect to Bid'}
        </Button>
      </VStack>

      {itemDetails && (
        <Box mt="5" p="5" borderWidth="1px" borderRadius="lg">
          <Text><strong>Users watching the bidding:</strong> {counts}</Text>
          <Text><strong>Bid Count:</strong> {bidCount}</Text>
          <Text><strong>Item Name:</strong> {itemDetails?.name}</Text>
          <Text><strong>min Bid Increment:</strong> {itemDetails?.minBidIncrement} LE</Text>
          <Text><strong>Description:</strong> {itemDetails?.description}</Text>
          <Text><strong> Price Now:</strong> {itemDetails?.startPrice} LE</Text>
          <Text><strong>End Date:</strong> {new Date(itemDetails?.subcategoryId?.endDate).toLocaleString()}</Text>
          <Text><strong>Time Left:</strong> {timeLeft}</Text>
          {lastbid&& (
            <Text color={'green'}><strong>you is the lastbid:</strong>{itemDetails?.startPrice} </Text>
          )}
          <FormControl id="bidAmount" mt="5">
            <FormLabel>Bid Amount</FormLabel>
            <Input
              type="number"
              value={bidAmount}
              onChange={(e) => setBidAmount(e.target.value)}
            />
          </FormControl>
          <Button onClick={handlePlaceBid} colorScheme="teal" mt="3">
            Place Bid
          </Button>
        </Box>
      )}

      <Popover>
        <PopoverTrigger>
          <IconButton
            icon={<BellIcon />}
            aria-label="Notifications"
            variant="outline"
            mt="5"
          >
            {notifications?.length > 0 && (
              <Badge colorScheme="red" variant="solid" ml="1">
                {notifications.length}
              </Badge>
            )}
          </IconButton>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Notifications</PopoverHeader>
          <PopoverBody>
            {notifications?.length > 0 ? (
              notifications.map((notification, index) => (
                <Text key={index}>{notification}</Text>
              ))
            ) : (
              <Text>No notifications</Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <Box mt="10">
        {/* <Text fontSize="2xl" mb="5">Bid History</Text> */}
        {/* <Box>
          <Text fontSize="xl" mb="2">Items Bid On</Text>
          {bidHistory?.bidItems?.length > 0 ? (
            bidHistory?.bidItems?.map((item, index) => (
              <Box key={index} p="5" borderWidth="1px" borderRadius="lg" mb="3">
                <Text><strong>Item Name:</strong> {item.item.name}</Text>
                <Text><strong>Bid Amount:</strong> {item.amount} LE</Text>
                <Text><strong>Status:</strong> {item.item.endDate < new Date() ? 'Auction Ended' : 'Ongoing'}</Text>
              </Box>
            ))
          ) : (
            <Text>No items bid on yet.</Text>
          )}
        </Box> */}

        {/* <Box mt="5">
          <Text fontSize="xl" mb="2">Won Items</Text>
          {bidHistory.wonItems.length > 0 ? (
            bidHistory.wonItems.map((item, index) => (
              <Box key={index} p="5" borderWidth="1px" borderRadius="lg" mb="3">
                <Text><strong>Item Name:</strong> {item.item.name}</Text>
                <Text><strong>Winning Bid:</strong> {item.maxBid} LE</Text>
              </Box>
            ))
          ) : (
            <Text>No items won yet.</Text>
          )}
        </Box> */}
{/* 
        <Box mt="5">
          <Text fontSize="xl" mb="2">Lost Items</Text>
          {bidHistory.lostItems.length > 0 ? (
            bidHistory.lostItems.map((item, index) => (
              <Box key={index} p="5" borderWidth="1px" borderRadius="lg" mb="3">
                <Text><strong>Item Name:</strong> {item.item.name}</Text>
                <Text><strong>Highest Bid:</strong> {item.highestBid.amount} LE</Text>
              </Box>
            ))
          ) : (
            <Text>No items lost yet.</Text>
          )}
        </Box> */}
      </Box>
    </Box>
    </Box>
    <Box width={'50%'}>
    <Text>Notifications</Text>
<Notifications/>
    </Box>
    </Box>
 
  );
};

export default BidForm;


